import { useGetUserUploadedFilesQuery } from './__generated__/uploadedFiles.generated';

export const useFiles = () => {
	const { data, ...queryFields } = useGetUserUploadedFilesQuery({
		fetchPolicy: 'cache-and-network',
	});

	return { files: data?.currentUser.uploadedFiles || [], ...queryFields };
};
